import { createContext, useContext, useEffect, useState } from "react";
import { getContent } from "./api";
import { CONTENT_DEFAULTS } from "../data/content";

const ContentContext = createContext({});

export function ContentProvider({ children }) {
  const [overrides, setOverrides] = useState({});
  useEffect(() => {
    getContent().then(setOverrides).catch(() => {});
  }, []);
  return <ContentContext.Provider value={overrides}>{children}</ContentContext.Provider>;
}

/**
 * Retourne la fonction c(key, fallback?) : le texte/l'image personnalisé(e)
 * depuis l'admin s'il existe, sinon la valeur par défaut du registre de contenus.
 */
export const useContent = () => {
  const overrides = useContext(ContentContext);
  return (key, fallback) => {
    const v = overrides[key];
    if (typeof v === "string" && v.length > 0) return v;
    if (fallback !== undefined) return fallback;
    return CONTENT_DEFAULTS[key] ?? "";
  };
};
